<template>
  <div>
    <Loader v-if="loading" />
    <b-row v-else>
      <b-col cols="12" md="4">
        <div class="card p-3">
          <div class="section-title">موضوع <span style="color: rgb(254, 94, 97)">*</span></div>
          <div class="mt-3">
            <BaseText :maxlength="2000" :value="search" @input="search = $event" placeholder="جستجو" />
          </div>
          <div :class="{ subject: filteredCategory.length > 5 }">
            <Radio :componentData="filteredCategory" :value="model.packageCategoryId" @input="model.packageCategoryId = $event" />
          </div>

          <label v-if="submit && !model.packageCategoryId" :class="{ course_type_error: submit && !model.packageCategoryId }">{{ errorText }}</label>
          <div v-if="$route.path.includes('agent')" class="subject-tip">جهت افزودن موضوع جدید با واحد آموزش ارتباط برقرارکنید</div>
        </div>

        <div class="card p-3 mt-3 my-auto d-flex flex-column justify-content-between">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex justify-content-between w-100">
              <div>
                <b-form-checkbox v-model="model.isDisplayable" class="pt-2 membersEnable">
                  <div class="mx-1">نمایش در صفحه خانه</div>
                </b-form-checkbox>

                <b-form-checkbox v-model="model.guaranteedEmployment" class="pt-2 d-flex align-items-center membersEnable">
                  <div class="mx-1 w-100">ضمانت اشتغال</div>
                </b-form-checkbox>

                <b-form-checkbox v-model="model.notShowPackageContent" class="pt-2 d-flex align-items-center membersEnable">
                  <div class="mx-1 w-100">عدم نمایش برنامه آموزشی</div>
                </b-form-checkbox>
                <b-form-checkbox v-model="model.isRecommended" class="pt-2">
                  <div class="mx-1">بسته پیشنهادی</div>
                </b-form-checkbox>
              </div>

              <div>
                <b-form-checkbox v-model="model.isEnable" class="pt-2">
                  <div class="mx-1">عدم نمایش بسته</div>
                </b-form-checkbox>
                <b-form-checkbox v-model="model.enableForMembers" class="pt-2 d-flex align-items-center membersEnable">
                  <div class="mx-1 w-100">فعال بودن بسته فقط برای اعضا</div>
                </b-form-checkbox>
                <b-form-checkbox v-model="model.allowSnapPay" class="pt-2">
                  <div class="mx-1">پرداخت با اسنپ‌پی</div>
                </b-form-checkbox>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end mt-3">
            <b-button @click="$bvModal.show('deleteModal')" variant="outline-secondary">
              <i class="far fa-times-circle"></i>
              <span class="ms-2">حذف بسته</span>
            </b-button>
          </div>
        </div>
        <div class="card p-3 mt-3">
          <BaseText :maxlength="2000" v-model="model.order" title="ترتیب بسته پیشنهادی" placeholder="" class="mt-2" />
        </div>

        <div class="card my-3 p-3">
          <ComboBox
            v-if="!$route.path.includes('faculty')"
            :searchedData="courseFacultis"
            title="تامین کننده"
            placeholder="تامین کننده"
            :required="$route.fullPath.includes('facultyskilluppackages') ? false : true"
            :showError="submit && !$route.path.includes('faculty') && !model.facultyId"
            :selectedValue="selectedFaculti"
            :errortext="errorText"
            @select="fillSelectedFaculti"
            :inputStyle="comboStyle"
          />
          <BaseText v-else disable :maxlength="2000" :value="model.facultyTitle" @input="model.facultyTitle = $event" title="تامین کننده" placeholder="تامین کننده" />
        </div>
        <div v-if="!$route.path.includes('agent')" class="card mb-3 p-3">
          <ComboBox
            :searchedData="collegues"
            title="دانشگاه‌های همکار"
            placeholder="دانشگاه‌های همکار"
            :selectedValue="selectedCollegue"
            @select="fillSelectedcollegue"
            :inputStyle="comboStyle"
          />
        </div>
        <div class="card my-3 p-3">
          <div class="section-title">نحوه ی فروش دوره</div>
          <Radio :componentData="buyMethod" :value="model.advisory" @input="model.advisory = $event" class="buymethod" />
        </div>

        <div class="inner__style mt-3">
          <div
            v-if="images.length === 0"
            class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center"
            @click="(event) => (images.length === 2 ? event.preventDefault() : $refs.fileInput.click())"
          >
            <div>
              <i :class="['fas fa-cloud-upload-alt __icon', { 'fas fa-spinner fa-spin': cropperLoading }]"></i>
              <div class="upload-text-size">عکس بسته را انتخاب کنید</div>
            </div>
          </div>
          <div v-else class="grand-parent">
            <div class="uploaded-photo-main">
              <div v-for="(image, index) in images" :key="index" class="uploaded-photo">
                <div class="remove-icon" @click="removeImage({ index, image })">
                  <i class="fa fa-times"></i>
                </div>
                <img class="previewImage" @click="changeSelectedImage(image)" :src="image" :class="{ selected: model.selectedImage == image }" />
              </div>
              <div v-if="images.length < 2" @click="() => $refs.fileInput.click()" class="uploaded-photo addNewImageIconContainer">
                <i :class="['fa fa-plus', { 'fas fa-spinner fa-spin': cropperLoading }]"></i>
              </div>
            </div>
          </div>
          <div class="my-3">
            <TextAreaInput
              :maxlength="100"
              :value="model.selectedImageAlternateText"
              @input="model.selectedImageAlternateText = $event"
              title="متن جایگزین 1"
              placeholder="متن جایگزین"
              rows="2"
            />
          </div>
          <div class="my-3">
            <TextAreaInput rows="2" :maxlength="100" :value="model.imageAlternateText" @input="model.imageAlternateText = $event" title="متن جایگزین 2" placeholder="متن جایگزین" />
          </div>
          <input style="display: none" type="file" accept="image/*" @change="onFileSelected" ref="fileInput" />
        </div>

        <div class="card my-3 p-4">
          <div class="d-flex flex-column">
            <div :class="['upload_video my-4', { 'justify-content-start': model.summaryVideo && !videoLoading }]" @click="onOpenSummaryVideoModal">
              <div v-if="model.summaryVideo || summaryVideoLoading">
                <div>
                  <i v-if="summaryVideoLoading" class="fas fa-spin fa-spinner icon-size"></i>

                  <div v-else style="position: relative">
                    <div>
                      <video :src="model.summaryVideo" controls class="video" />

                      <i class="fas fa-times-circle close_icon" @click="model.summaryVideo = ''"></i>
                    </div>
                  </div>

                  <div v-if="summaryVideoLoading" class="pro">
                    <div class="progress-b">
                      <b-progress :value="summaryVideoPercentCompleted ? summaryVideoPercentCompleted : 0" :max="100" animated height="10" />
                    </div>

                    <div class="percent">{{ summaryVideoPercentCompleted ? summaryVideoPercentCompleted : 0 }}%</div>
                  </div>
                </div>
              </div>

              <div v-else>
                <i class="fas fa-cloud-upload-alt icon-size"></i>

                <div class="upload_text">خلاصه ویدئو بسته را انتخاب کنید</div>

                <div class="second_upload_text">ویدئو به صورت افقی باید برگزاری شود</div>
              </div>
            </div>
            <BaseText v-model="model.summaryVideoName" title="نام ویدئو" placeholder="نام ویدئو" />
          </div>
        </div>

        <div class="card my-3 p-4">
          <div class="d-flex flex-column">
            <div :class="['upload_video my-4', { 'justify-content-start': model.video && !videoLoading }]" @click="onOpenVideoModal">
              <div v-if="model.video || videoLoading">
                <div>
                  <i v-if="videoLoading" class="fas fa-spin fa-spinner icon-size"></i>

                  <div v-else style="position: relative">
                    <div>
                      <video :src="model.video" controls class="video" />

                      <i class="fas fa-times-circle close_icon" @click="model.video = ''"></i>
                    </div>
                  </div>

                  <div v-if="videoLoading" class="pro">
                    <div class="progress-b">
                      <b-progress :value="videoPercentCompleted ? videoPercentCompleted : 0" :max="100" animated height="10" />
                    </div>

                    <div class="percent">{{ videoPercentCompleted ? videoPercentCompleted : 0 }}%</div>
                  </div>
                </div>
              </div>

              <div v-else>
                <i class="fas fa-cloud-upload-alt icon-size"></i>

                <div class="upload_text">ویدئو تبلیغاتی بسته را انتخاب کنید</div>

                <div class="second_upload_text">ویدئو به صورت افقی باید برگزاری شود</div>
              </div>
            </div>
            <BaseText v-model="model.videoName" title="نام ویدئو" placeholder="نام ویدئو" />
          </div>
        </div>

        <div v-if="model.licenseStatus && model.licenseStatus > 0" class="card mt-3 p-3">
          <div class="d-flex justify-content-between">
            <strong>وضعیت درخواست</strong>
            <div v-if="model.licenseStatus === 4" class="accept-badge">تایید شده</div>
            <div v-if="model.licenseStatus === 3" class="reject-badge">رد شده</div>
            <div v-if="model.licenseStatus === 2" class="need-badge">نیاز به اصلاح</div>
            <div v-if="model.licenseStatus === 1" class="waiting-badge">در حال بررسی</div>
          </div>
          <template v-if="model.licenseStatus === 3 || model.licenseStatus === 2">
            <div class="mt-3">علت رد درخواست:</div>
            <div class="mt-2">{{ model.licenseDescription }}</div>
          </template>
        </div>
      </b-col>
      <b-col cols="12" md="8">
        <div class="card">
          <Section title="اطلاعات بسته">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.title" @input="model.title = $event" title="عنوان بسته" placeholder="عنوان بسته" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.shortDescription" @input="model.shortDescription = $event" title="توضیحات کوتاه" placeholder="توضیحات کوتاه" />
            </div>

            <div class="my-3">
              <EditorInput :value="model.fullDescription" @input="model.fullDescription = $event" title="توضیحات کلی" textAreaClass="align-items-center" />
            </div>
          </Section>
        </div>
        <div class="card">
          <div class="date-header">اطلاعات اولیه بسته</div>
          <Section title="تعداد درس ها">
            <div>
              <BaseText :maxlength="2000" :value="model.numberOfSessions" @input="model.numberOfSessions = $event" title="تعداد درس ها" placeholder="تعداد درس ها" />
            </div>
          </Section>
          <Section title="مدت بسته">
            <div>
              <BaseText :maxlength="2000" :value="model.duration" @input="model.duration = $event" title="مدت بسته" placeholder="مدت بسته" />
            </div>
          </Section>
          <Section title="تاریخ بسته">
            <div>
              <DateTimeOffset range :value="dateRange" @input="dateRange = $event" title="تاریخ بسته" placeholder="تاریخ بسته" :hasDefaultDate="false" :key="dateRender" />
            </div>
          </Section>
          <Section title="تاریخ انتشار">
            <div>
              <DateTimeOffset
                :value="model.releaseDate"
                @input="model.releaseDate = $event"
                title="تاریخ انتشار"
                placeholder="تاریخ انتشار"
                :hasDefaultDate="false"
                :key="dateRender"
              />
            </div>
          </Section>

          <Section title="مدرک">
            <ComboBox
              :searchedData="packageCertificates"
              title="اعطا گواهی معتبر"
              placeholder="اعطا گواهی معتبر"
              :selectedValue="selectedCertificate"
              @select="fillSelectedCertificate"
              :inputStyle="comboStyle"
            />
          </Section>

          <Section title="ظرفیت">
            <div>
              <CountInput inputType="number" :value="model.capacity" @input="model.capacity = $event" title="ظرفیت" placeholder="ظرفیت" />
            </div>
          </Section>

          <Section title="مهلت ثبت نام">
            <div>
              <DateTimeOffset
                :value="model.deadlineDate"
                @input="model.deadlineDate = $event"
                title="مهلت ثبت نام"
                placeholder="مهلت ثبت نام"
                :hasDefaultDate="false"
                :key="dateRender"
              />
            </div>
          </Section>
          <Section title="اپلود بنر جزییات صفحه">
            <b-row>
              <b-col>
                <ImageUploader
                  :img="model.bannerImage"
                  :uploadLoading="bannerImageLoading"
                  title="عکس بنر را انتخاب کنید"
                  secondTitle="در صفحه شغل ها سایز 1920x 770 و در صفحه بسته ها سایز 1920x 660"
                  @uploadImage="uploadbannerImage"
                  @deleteImage="model.bannerImage = ''"
                />
              </b-col>
              <div class="mt-2">
                <BaseText v-model="model.bannerImageAlternateText" title="متن جایگزین " placeholder="متن جایگزین " labelClass="labelClass" :maxlength="2000" />
              </div>
            </b-row>
          </Section>
          <Section title="ویژگی های بسته مشاوره ایی">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.propertyOne" @input="model.propertyOne = $event" title="ویژگی یک" placeholder="ویژگی یک" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.propertyTwo" @input="model.propertyTwo = $event" title="ویژگی دو" placeholder="ویژگی دو" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.propertyThree" @input="model.propertyThree = $event" title="ویژگی سه" placeholder="ویژگی سه" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.propertyFour" @input="model.propertyFour = $event" title="ویژگی چهار" placeholder="ویژگی چهار" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.propertyFive" @input="model.propertyFive = $event" title="ویژگی پنج" placeholder="ویژگی پنج" />
            </div>
          </Section>
        </div>
        <div class="card">
          <Section title="ویژگی های بسته پولی ">
            <template v-for="(item, index) in findPackageProps(1)">
              <div class="my-3" :key="index + item.type">
                <BaseText :maxlength="2000" :value="item.title" @input="item.title = $event" :title="'ویژگی ' + (item.order + 1)" :placeholder="'ویژگی ' + (item.order + 1)" />
              </div>
            </template>
          </Section>
        </div>
        <div class="card">
          <div class="date-header">دستاوردها در بسته پولی</div>
          <Section title="آنچه در این دوره خواهید آموخت ">
            <template v-for="(item, index) in findPackageProps(2)">
              <div class="my-3" :key="index + item.type">
                <BaseText :maxlength="2000" :value="item.title" @input="item.title = $event" :title="'توضیحات ' + (item.order + 1)" :placeholder="'توضیحات ' + (item.order + 1)" />
              </div>
            </template>
          </Section>
        </div>
        <div ref="income" class="card">
          <div class="date-header">دستاورد ها در بسته مشاوره ای</div>
          <Section title="آینده و درآمد">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.income" @input="model.income = $event" title="درآمد" placeholder="درآمد" />
            </div>
            <div class="my-3">
              <TextAreaInput :value="model.incomeDescription" @input="model.incomeDescription = $event" title="توضیحات" placeholder="توضیحات" rows="3" />
            </div>
          </Section>
          <Section title="دستاورد شما">
            <div class="my-3">
              <TextAreaInput :value="model.achievementDescription" @input="model.achievementDescription = $event" title="در این آکادمی" placeholder="در این آکادمی" rows="3" />
            </div>
          </Section>
          <Section title="پایان دوره ">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.endingDescription" @input="model.endingDescription = $event" title="توضیحات" placeholder="توضیحات" />
            </div>
          </Section>
          <Section title="استخدام در شرکت ها">
            <div class="d-flex">
              <div class="d-flex align-items-center me-5">لوگوها</div>
              <div class="w-100 ms-2">
                <div class="inner__style mt-3">
                  <input style="display: none" type="file" accept="image/*" @change="onHireImagesFileSelected" ref="fileInputLogo" />
                  <div
                    v-if="hireImages.length === 0"
                    class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center"
                    @click="(event) => (hireImages.length === 2 ? event.preventDefault() : $refs.fileInputLogo.click())"
                  >
                    <div>
                      <i :class="['fas fa-cloud-upload-alt __icon', { 'fas fa-spinner fa-spin': hireImagesLoading }]"></i>
                      <div class="upload-text-size">عکس مورد نظر را بارگذاری نمایید</div>
                    </div>
                  </div>
                  <div v-else class="grand-parent">
                    <div class="uploaded-photo-main">
                      <div v-for="(image, index) in hireImages" :key="index" class="uploaded-photo">
                        <div class="remove-icon" @click="removeCustomImage({ index, image }, 'hireImages')">
                          <i class="fa fa-times"></i>
                        </div>
                        <img class="previewImage" :src="image" />
                      </div>
                      <div v-if="hireImages.length < 5" @click="() => $refs.fileInputLogo.click()" class="uploaded-photo addNewImageIconContainer">
                        <i :class="['fa fa-plus', { 'fas fa-spinner fa-spin': hireImagesLoading }]"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Section>
        </div>
        <div class="card">
          <Section title="ابزارهای که یاد میگیرید  ">
            <div class="d-flex">
              <div class="d-flex"></div>
              <div class="d-flex align-items-center me-5">ابزارها</div>

              <div class="w-100 ms-2">
                <div class="inner__style mt-3">
                  <input style="display: none" type="file" accept="image/*" @change="onEndingImagesFileSelected" ref="fileInput3" />
                  <div
                    v-if="endingImages.length === 0"
                    class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center"
                    @click="(event) => (endingImages.length === 2 ? event.preventDefault() : $refs.fileInput3.click())"
                  >
                    <div>
                      <i :class="['fas fa-cloud-upload-alt __icon', { 'fas fa-spinner fa-spin': endingImagesLoading }]"></i>
                      <div class="upload-text-size">عکس مورد نظر را بارگذاری نمایید</div>
                    </div>
                  </div>
                  <div v-else class="grand-parent">
                    <div class="uploaded-photo-main">
                      <div v-for="(image, index) in endingImages" :key="index" class="uploaded-photo">
                        <div class="remove-icon" @click="removeCustomImage({ index, image }, 'endingImages')">
                          <i class="fa fa-times"></i>
                        </div>
                        <img class="previewImage" :src="image" />
                      </div>
                      <div v-if="endingImages.length < 5" @click="() => $refs.fileInput3.click()" class="uploaded-photo addNewImageIconContainer">
                        <i :class="['fa fa-plus', { 'fas fa-spinner fa-spin': endingImagesLoading }]"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Section>
        </div>
        <div class="card">
          <Section title="ویژگی های کلی تک درس های  یک دوره جامع ">
            <template v-for="(item, index) in findPackageProps(3)">
              <div class="my-3" :key="index + item.type">
                <BaseText :maxlength="2000" :value="item.title" @input="item.title = $event" :title="'ویژگی ' + (item.order + 1)" :placeholder="'ویژگی ' + (item.order + 1)" />
              </div>
            </template>
          </Section>
          <div class="my-2" style="color: #2563eb; text-align: center">ادمین گرامی در نظر داشته باشید دو ویژگی اول وارد شده در نسخه های کوچیک تر قابل نمایش می باشد.</div>
        </div>
        <div v-if="model.advisory === false" class="card">
          <div class="date-header">توضیحات پروموت بخش خرید</div>
          <Section title="عنوان  ">
            <template v-for="(item, index) in findPackageProps(4)">
              <div class="my-3" :key="index + item.type">
                <BaseText :maxlength="2000" :value="item.title" @input="item.title = $event" :title="'عنوان توضیح '" :placeholder="'عنوان توضیح '" />
              </div>
            </template>
          </Section>
          <Section title="ویژگی ها  ">
            <template v-for="(item, index) in findPackageProps(5)">
              <div class="my-3" :key="index + item.type">
                <BaseText :maxlength="2000" :value="item.title" @input="item.title = $event" :title="'ویژگی ' + (item.order + 1)" :placeholder="'ویژگی ' + (item.order + 1)" />
              </div>
            </template>
          </Section>
        </div>
        <div class="card">
          <Section title="توضیحات اعطای مدرک ">
            <template v-for="(item, index) in findPackageProps(6)">
              <div class="my-3" :key="index + item.type">
                <BaseText :maxlength="2000" :value="item.title" @input="item.title = $event" :title="'عنوان '" :placeholder="'عنوان '" />
              </div>
            </template>
            <template v-for="(item, index) in findPackageProps(7)">
              <div class="my-3" :key="index + item.type">
                <TextAreaInput :maxlength="2000" :value="item.title" @input="item.title = $event" :title="'توضیحات '" :placeholder="'توضیحات '" />
              </div>
            </template>
            <div class="card">
              <Section title="اپلود عکس">
                <template v-for="(item, index) in findPackageProps(8)">
                  <div class="my-3" :key="index + item.type">
                    <b-row>
                      <b-col>
                        <ImageUploader
                          :img="item.title"
                          :uploadLoading="certificateImageLoading"
                          title="عکس خود را انتخاب کنید"
                          secondTitle="سایز 570 * 330"
                          @uploadImage="uploadCertificateImage"
                          @deleteImage="item.title = ''"
                        />
                      </b-col>
                    </b-row>
                  </div>
                </template>
              </Section>
            </div>
          </Section>
        </div>

        <div class="card">
          <Section title="توضیحات بخش ویدئو">
            <div>
              <EditorInput :value="model.extraDescription" @input="model.extraDescription = $event" title="توضیحات" :hasImage="false" textAreaClass="align-items-center" />
            </div>
          </Section>
        </div>
        <div v-if="model.advisory" class="card">
          <div class="date-header">فرایند پذیرش در دوره</div>
          <Section title="مشاوره">
            <Dragable :items="model.advisorySettings" draggable=".drag">
              <div v-for="(item, index) in model.advisorySettings" :key="index" class="d-flex justify-content-between mb-4" style="cursor: move" :class="{ drag: item.validDate }">
                <div class="part">
                  <strong class="me-3">دوره{{ ' ' + (index + 1) }}</strong>
                  <div class="w-100">
                    <DateTimeOffset :value="item.createdDate" @input="item.createdDate = $event" title="تاریخ " placeholder="تاریخ برگزاری دوره" :hasDefaultDate="false" />
                  </div>
                </div>
                <div class="w-50 ms-4">
                  <DateTimeOffset :value="item.validDate" @input="item.validDate = $event" title="مهلت ثبت نام" placeholder="مهلت ثبت نام" :hasDefaultDate="false" />
                </div>
              </div>
            </Dragable>
          </Section>
        </div>

        <div v-else class="card">
          <div class="date-header">فرایند ثبت نام در دوره</div>

          <Section title="خرید نقدی">
            <div class="d-flex justify-content-between">
              <div class="w-50">
                <BaseText :maxlength="2000" :value="model.price" @input="model.price = $event" title="قیمت" placeholder="قیمت (تومان) " />
              </div>
              <div class="w-50 ms-4">
                <BaseText :maxlength="2000" :value="model.discount" @input="model.discount = $event" title="قیمت با تخفیف" placeholder="قیمت با تخفیف (تومان) " />
              </div>
            </div>
          </Section>

          <Section title="خرید اقساطی">
            <strong v-if="installmentError" class="py-3 d-block text-danger">لطفا فیلد های اقساط رو به درستی وارد نمایید</strong>
            <Dragable :items="model.installmentPayments" draggable=".drag">
              <div v-for="(item, index) in filterPeyments" :key="index" class="d-flex justify-content-between mb-4" style="cursor: move" :class="{ drag: item.validDate }">
                <div class="part">
                  <strong class="me-3">قسط{{ index + 1 }}</strong>
                  <div class="w-100">
                    <BaseText :maxlength="2000" :value="item.price" @input="item.price = $event" labelClass="label-no-width" title="مبلغ" placeholder="مبلغ (تومان) " />
                  </div>
                </div>
                <div v-if="index === 0" class="w-50 ms-4">
                  <BaseText :disable="true" :maxlength="2000" value="در زمان خرید کاربر " title="تاریخ پرداخت" placeholder="تاریخ پرداخت" />
                </div>
                <div v-else class="w-50 ms-4 position-relative">
                  <RadioComboBox
                    :searchedData="month"
                    title="تاریخ پرداخت"
                    placeholder="تاریخ پرداخت"
                    :selectedValue="selectedBuyAfterMonth(item)"
                    @select="item.monthAfterBuy = $event"
                    :inputStyle="comboStyle"
                  />
                  <span v-if="item.monthAfterBuy > 0" class="month-after">ماه بعد از خرید</span>
                </div>
              </div>
            </Dragable>
          </Section>
        </div>

        <div class="card">
          <Section title="توضیحات پایانی صفحات">
            <div>
              <EditorInput :value="model.moreContent" @input="model.moreContent = $event" title="محتوای صفحه" :hasImage="false" textAreaClass="align-items-center" />
            </div>
          </Section>
        </div>
        <!-- <div class="card">
          <Section title="توضیحات پایانی صفحات ">
            <template v-for="(item, index) in findPackageProps(9)">
              <div :key="index + item.type">
                <EditorInput :value="item.title" @input="item.title = $event" title="توضیحات" :hasImage="false" textAreaClass="align-items-center" />
              </div>
            </template>
          </Section>
        </div> -->
        <div class="card">
          <Section title="تنظیمات سئو">
            <div class="my-3">
              <Tags title="کلیدواژه" :value="model.seoKeyword" classes="tags" @input="model.seoKeyword = $event" placeholder="کلیدواژه" />
            </div>
            <div class="my-3">
              <TextAreaInput :value="model.seoDescription" @input="model.seoDescription = $event" title="توضیحات" textAreaClass="align-items-center" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.seoUrlDescription" @input="model.seoUrlDescription = $event" title="متن URL" placeholder="متن URL" />
            </div>
          </Section>
        </div>
      </b-col>
    </b-row>
    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button variant="outline-secondary" @click="$router.push($route.path.includes('faculty') ? '/list/facultyskillupcourses' : '/list/skillupcourses')">انصراف</b-button>
      <b-button :class="{ disable: isFaculty }" variant="primary ms-2 px-5" @click="addPackage">ثبت پیش نویس</b-button>
    </div>
    <b-modal id="deleteModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="@/assets/images/checked1.svg" />
        </div>
        <div class="error-title text-center">آیا از حذف بسته اطمینان دارید؟</div>
        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button class="col-6" variant="secondary" block @click="$bvModal.hide('deleteModal')">خیر</b-button>
            <b-button class="ms-2 col-6" variant="primary" block @click="deletePackage">بله</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <Toast :title="message" :error="error" :showToast="message !== ''" />

    <b-modal id="videoModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title no-close-on-backdrop @close="closeVideoUpload">
      <template #modal-title>بارگذاری ویدئو</template>

      <div class="p-3">
        <VideoUpload
          :percent="videoPercentCompleted"
          accept="video/*"
          uploadButtonLabel="تایید"
          :loading="cropperLoading"
          @videoSourceChanged="uploadVideo($event)"
          @close="closeVideoUpload"
        />
      </div>
    </b-modal>

    <b-modal id="summaryVideoModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title no-close-on-backdrop @close="closeSummaryVideoUpload">
      <template #modal-title>بارگذاری خلاصه ویدئو</template>

      <div class="p-3">
        <VideoUpload
          :percent="summaryVideoPercentCompleted"
          accept="video/*"
          uploadButtonLabel="تایید"
          :loading="cropperLoading"
          @videoSourceChanged="uploadSummaryVideo($event)"
          @close="closeSummaryVideoUpload"
        />
      </div>
    </b-modal>
  </div>
</template>
<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import fileMannager from '../../../services/file'
import skillUpPackageProvider from '../../../services/skillUp/package'
import Toast from '../../common/Toast.vue'
import Loader from '../../widgets/loader.vue'
import Section from '../../common/form/Section.vue'
import Radio from '../../common/form/formModules/Radio.vue'
import DateTimeOffset from '../../common/form/formModules/DateTimeOffset.vue'
import ComboBox from '../../common/form/formModules/ComboBox.vue'
import EditorInput from '../../common/form/formModules/editorInput.vue'
import axios from 'axios'
import VideoUpload from '../../common/form/VideoUpload.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'
import Tags from '../../common/form/formModules/Tags.vue'
import ImageUploader from '../../user/ImageUploader.vue'
import Dragable from '../../common/Dragable.vue'
import CountInput from '../../common/form/CountInput.vue'
import RadioComboBox from '../../common/form/formModules/RadioComboBox.vue'

let controller = new AbortController()
export default {
  name: 'AddPackage',
  components: {
    Toast,
    Loader,
    Section,
    BaseText,
    Radio,
    DateTimeOffset,
    EditorInput,
    VideoUpload,
    ComboBox,
    TextAreaInput,
    Tags,
    ImageUploader,
    Dragable,
    CountInput,
    RadioComboBox,
  },
  props: {
    create: {
      type: Boolean,
      default: false,
    },
    update: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        facultyId: '',
        collegueId: '',
        code: undefined,
        title: '',
        englishTitle: '',
        shortDescription: '',
        extraDescription: '',
        numberOfSessions: '',
        hasCertificate: false,
        deadlineDate: '',
        capacity: undefined,
        isDisplayable: false,
        duration: '',
        startDate: '',
        endDate: '',
        releaseDate: '',
        fullDescription: '',
        enableForMembers: false,
        price: 0,
        discount: '',
        isEnable: false,
        image: '',
        imageAlternateText: '',
        selectedImage: '',
        selectedImageAlternateText: '',
        packageCategoryId: '',
        video: '',
        videoName: '',
        summaryVideo: '',
        summaryVideoName: '',
        installmentPayments: [
          {
            price: '',
            order: 0,
            monthAfterBuy: 0,
          },
        ],
        advisorySettings: [
          {
            order: 0,
            createdDate: '',
            validDate: '',
          },
        ],
        bannerImage: '',
        bannerImageAlternateText: '',
        moreContent: '',
        images: [],
        propertyOne: '',
        propertyTwo: '',
        propertyThree: '',
        propertyFour: '',
        propertyFive: '',
        income: '',
        incomeDescription: '',
        achievementDescription: '',
        endingDescription: '',
        endingImages: '',
        hireImages: '',
        advisory: false,
        guaranteedEmployment: false,
        notShowPackageContent: false,
        installmentError: false,
        allowSnapPay: false,
        packageProperties: [],
        isRecommended: false,
        order: '',
      },
      collegues: [],
      packageCertificates: [],
      selectedCertificate: '',
      endingImages: [],
      hireImages: [],
      errorText: 'وارد کردن این فیلد الزامی است.',
      search: '',
      comboStyle: 'color: #495057',
      selectedTeachers: [],
      selectedFaculti: '',
      selectedCollegue: '',
      numberOfAddedCourse: null,
      buyMethod: [
        {
          value: 'پولی',
          key: false,
        },
        {
          value: 'مشاوره ای',
          key: true,
        },
      ],
      packageCategories: [],
      courseTeachers: [],
      courseFacultis: [],
      dateRange: [],
      images: [],
      message: '',
      cropperLoading: false,
      submit: false,
      error: false,
      loading: false,
      videoLoading: false,
      summaryVideoLoading: false,
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت بسته', active: true },
      ],
      imageCrop: { width: 600, height: 200 },
      updateForm: false,
      dateRender: true,
      videoPercentCompleted: 0,
      summaryVideoPercentCompleted: 0,
      bannerImageLoading: false,
      endingImagesLoading: false,
      hireImagesLoading: false,
      installmentError: false,
      certificateImageLoading: false,
    }
  },
  watch: {
    'model.deadlineDate'(c) {
      if (c && !c.includes('T')) {
        this.model.deadlineDate = this.model.deadlineDate.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
    },
    checkLastPaymentDate(c) {
      if (c && !this.submit) {
        this.model.installmentPayments.push({
          price: '',
          monthAfterBuy: '',
        })
      }
    },
    checkLastAdvisoryDate(c) {
      if (c && !this.submit) {
        this.model.advisorySettings.push({
          createdDate: '',
          validDate: '',
        })
      }
    },
    checkLastPaymentprice(c) {
      const last = this.model.installmentPayments?.length - 1
      const item = this.model.installmentPayments[last]?.price
      if (item === c && !this.submit) {
        this.model.installmentPayments[last].price = item?.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    filterPeyments() {
      this.model.installmentPayments.forEach((item, index) => {
        item.order = index
      })
    },
    'model.advisorySettings'() {
      this.model.advisorySettings.forEach((item, index) => {
        item.order = index
      })
    },

    'model.releaseDate'(c) {
      if (c && !c.includes('T')) {
        this.model.releaseDate = this.model.releaseDate.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
    },
    'model.price'(c) {
      if (c && !this.submit) {
        this.model.price = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    'model.discount'(c) {
      if (c && !this.submit) {
        this.model.discount = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },

    'images.length'(c) {
      const selected = this.images[0]
      if (c <= 1) {
        if (!this.model.selectedImage && this.images.length) {
          this.model.selectedImage = selected
        }
      }
    },
    dateRange(c) {
      if (c.length === 1) {
        const start = c[0]
        const end = c[0]
        this.model.startDate = start.replaceAll('/', '-') + 'T00:00:00.000Z'
        this.model.endDate = end.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
      if (c.length > 1) {
        const start = c[0]
        const end = c[1]
        this.model.startDate = start.replaceAll('/', '-') + 'T00:00:00.000Z'
        this.model.endDate = end.replaceAll('/', '-') + 'T00:00:00.000Z'
      }

      if (c.length === 1) {
        this.model.startDate = c[0].replaceAll('/', '-') + 'T00:00:00.000Z'
      }
      if (!c) {
        this.model.startDate = null
        this.model.endDate = null
      }
    },
  },
  computed: {
    month() {
      let out = []
      for (let i = 1; i <= 12; i++) {
        out.push({
          key: i,
          value: i + ' ماه بعد از خرید',
        })
      }
      return out
    },
    isFaculty() {
      return (
        (this.$route.path.includes('faculty') || this.$route.path.includes('support') || this.$route.path.includes('agent')) &&
        (this.model.licenseStatus === 4 || this.model.licenseStatus === 3)
      )
    },
    filterPeyments() {
      return this.model.installmentPayments.map((item) => {
        if (item.price) {
          item.price = item.price.toString()
          item.price = item.price.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
        return item
      })
    },
    checkLastPaymentDate() {
      const last = this.model.installmentPayments?.length - 1
      if (this.model.installmentPayments[last]?.price) {
        return this.model.installmentPayments[last]?.monthAfterBuy
      }
      return ''
    },
    checkLastAdvisoryDate() {
      const last = this.model.advisorySettings?.length - 1
      return this.model.advisorySettings[last]?.validDate
    },
    checkLastPaymentprice() {
      const last = this.model.installmentPayments?.length - 1
      return this.model.installmentPayments[last]?.price
    },
    filteredCategory() {
      return this.packageCategories.filter((item) => {
        return item.value.includes(this.search)
      })
    },
  },
  async mounted() {
    localStorage.removeItem('entityTitle')
    this.fetchPackageInputs()
    if (this.update) {
      await this.fetchPackage(+this.$route.params.packageId)
      // console.log(this.model.facultyId)
      this.model.isEnable = !this.model.isEnable ? true : false
      if (this.model.facultyId) this.fillSelectedFaculti(this.model.facultyTitle)
    } else this.initialPackageProps()
    this.loading = false
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 10)
    setTimeout(() => {
      if (this.model.installmentPayments.length === 1) {
        this.model.installmentPayments.push({
          price: '',
          monthAfterBuy: 0,
        })
      }

      this.dateRender = false
    }, 3000)
  },
  methods: {
    findPackageProps(type) {
      return this.model.packageProperties.filter((item) => item.type === type)
    },
    initialPackageProps(serverProps = []) {
      try {
        const maxCounts = {
          1: 4, // mainFeature
          2: 8, // achievement
          3: 3, // courseFeature
          4: 1, // buyPromoteTitle
          5: 5, // buyPromoteFeature
          6: 1, // certificateTitle
          7: 1, // certificateDescription
          8: 1, // certificateImage
          9: 1, // lastPageDescription
        }

        const defaultObj = {
          title: '',
          order: null,
          type: 1,
          id: null,
        }

        const propsArray = []

        const createKey = (type, order) => `${type}-${order !== null ? order : 'null'}`

        serverProps.forEach((prop) => {
          const key = createKey(prop.type, prop.order)
          if (!propsArray.some((p) => createKey(p.type, p.order) === key) && propsArray.filter((p) => p.type === prop.type).length < maxCounts[prop.type]) {
            propsArray.push(prop)
          }
        })

        const addDefaultProps = (type, max, hasOrder) => {
          if (hasOrder) {
            for (let i = 0; i < max; i++) {
              const key = createKey(type, i)
              if (!propsArray.some((p) => createKey(p.type, p.order) === key)) {
                const index = propsArray.findIndex((p) => p.type === type && p.order > i)
                const newProp = { ...defaultObj, type, order: i }

                if (index === -1) {
                  propsArray.push(newProp)
                } else {
                  propsArray.splice(index, 0, newProp)
                }
              }
            }
          } else {
            const key = createKey(type, null)
            if (!propsArray.some((p) => createKey(p.type, p.order) === key)) {
              propsArray.push({ ...defaultObj, type, order: null })
            }
          }
        }

        const typesWithOrder = [1, 2, 3, 5] // mainFeature, achievement, courseFeature, buyPromoteFeature
        const typesWithoutOrder = [4, 6, 7, 8, 9] // buyPromoteTitle, certificateTitle, certificateDescription, certificateImage, lastPageDescription

        typesWithOrder.forEach((type) => addDefaultProps(type, maxCounts[type], true))

        typesWithoutOrder.forEach((type) => addDefaultProps(type, maxCounts[type], false))

        this.model.packageProperties = propsArray
      } catch (error) {
        console.error('Error', error)
      }
    },
    onFileSelected(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        const img = new Image()
        img.src = e.target.result
        this.uploadImage(e.target.result)
      }

      reader.readAsDataURL(file)
    },
    onEndingImagesFileSelected(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = async (e) => {
        const img = new Image()
        img.src = e.target.result
        this.endingImagesLoading = true
        const req = await fileMannager.addImage({
          base64image: e.target.result,
        })
        this.endingImages.push(req.data.data.downloadUrl)
        this.endingImagesLoading = false
      }

      reader.readAsDataURL(file)
    },
    onHireImagesFileSelected(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = async (e) => {
        const img = new Image()
        img.src = e.target.result
        this.hireImagesLoading = true
        const req = await fileMannager.addImage({
          base64image: e.target.result,
        })
        this.hireImages.push(req.data.data.downloadUrl)
        this.hireImagesLoading = false
      }

      reader.readAsDataURL(file)
    },
    async uploadbannerImage(e) {
      this.bannerImageLoading = true
      const req = await fileMannager.addImage({
        base64image: e.dataUrl,
      })
      this.bannerImageLoading = false
      this.model.bannerImage = req.data.data.downloadUrl
    },
    async uploadCertificateImage(e) {
      this.certificateImageLoading = true
      const req = await fileMannager.addImage({
        base64image: e.dataUrl,
      })
      this.certificateImageLoading = false
      const find = this.model.packageProperties.findIndex((item) => item.type === 8)
      this.model.packageProperties[find].title = req.data.data.downloadUrl
    },
    closeVideoUpload() {
      this.$bvModal.hide('videoModal')
      controller.abort()
      this.videoLoading = false
      controller = new AbortController()
      this.videoPercentCompleted = 0

      this.model.video = ''
    },
    closeSummaryVideoUpload() {
      this.$bvModal.hide('summaryVideoModal')
      controller.abort()
      this.summaryVideoLoading = false
      controller = new AbortController()
      this.summaryVideoPercentCompleted = 0

      this.model.summaryVideo = ''
    },
    onOpenVideoModal() {
      if (this.model.video && this.model.video.length) return
      else this.$bvModal.show('videoModal')
    },
    onOpenSummaryVideoModal() {
      if (this.model.summaryVideo && this.model.summaryVideo.length) return
      else this.$bvModal.show('summaryVideoModal')
    },
    async uploadVideo(e) {
      try {
        this.cropperLoading = true
        this.videoLoading = true
        const req = await axios.post('FileManager/api/File/AddFiles', e, {
          onUploadProgress: (progressEvent) => {
            this.videoPercentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          },
          signal: controller.signal,
        })
        this.videoLoading = false

        this.model.video = req.data.data[0].downloadUrl
        setTimeout(() => {
          this.videoPercentCompleted = 0
          this.$bvModal.hide('videoModal')
        }, 2000)
      } catch (error) {
        this.cropperLoading = false
      }
      this.cropperLoading = false
    },
    async uploadSummaryVideo(e) {
      try {
        this.cropperLoading = true
        this.summaryVideoLoading = true
        const req = await axios.post('FileManager/api/File/AddFiles', e, {
          onUploadProgress: (progressEvent) => {
            this.summaryVideoPercentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          },
          signal: controller.signal,
        })
        this.summaryVideoLoading = false

        this.model.summaryVideo = req.data.data[0].downloadUrl
        setTimeout(() => {
          this.summaryVideoPercentCompleted = 0
          this.$bvModal.hide('summaryVideoModal')
        }, 2000)
      } finally {
        this.cropperLoading = false
      }
    },
    fillSelectedFaculti(e) {
      if (!e) {
        this.model.facultyId = null
        return false
      }
      this.model.facultyId = this.courseFacultis.find((item) => item.value === e)?.key
      this.selectedFaculti = this.courseFacultis.find((item) => item.value === e)?.value
    },
    checkRoute(id) {
      const mainRoute = this.$route.path.split('/')[2]
      setTimeout(() => {
        this.$router.push(`/list/${mainRoute}/detail/${id}`)
      }, 2000)
    },
    async addPackage() {
      this.submit = true
      if (!this.model.packageCategoryId || !this.model.facultyId) {
        setTimeout(() => {
          window.scrollTo(0, 0)
        }, 10)
        return false
      }
      // if (!this.model.income || !this.model.incomeDescription || !this.model.endingDescription || !this.hireImages.length || !this.endingImages.length) {
      //   setTimeout(() => {
      //     window.scrollTo(0, 2000)
      //   }, 10)
      //   return false
      // }
      if (this.model?.price) {
        this.model.price = this.model?.price.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.price = this.model?.price
      }

      this.model.installmentPayments.forEach((item, index) => {
        const empty = this.model.installmentPayments.findIndex((item) => item.price === '')
        if (!item.price) {
          this.model.installmentPayments.splice(empty, 1)
        }

        // item.validDate = !item.validDate.includes('T') ? item.validDate.replaceAll('/', '-') + 'T00:00:00.000Z' : item.validDate
        if (item.price && item.price !== '') {
          item.price = item.price.replace(/[^a-zA-Z0-9 ]/g, '')
          item.price = +item.price
        }
      })

      if (typeof this.model.installmentPayments[0].price === 'string' && this.model.installmentPayments[1]?.price) {
        this.submit = false
        this.installmentError = true
        this.model.installmentPayments.unshift({
          price: '',
          monthAfterBuy: 0,
        })
        this.model.installmentPayments[1].monthAfterBuy = null
        setTimeout(() => {
          window.scrollTo(0, 4500)
        }, 10)
        this.loading = false
        return false
      }
      this.installmentError = false
      if (this.model.installmentPayments.length === 1 && !this.model.installmentPayments[0].price) {
        this.model.installmentPayments = []
      }

      this.model.advisorySettings.forEach((item) => {
        const empty = this.model.advisorySettings.findIndex((item) => item.validDate === '')
        if (!item.createdDate || !item.validDate) {
          this.model.advisorySettings.splice(empty, 1)
        }
        item.validDate = !item.validDate.includes('T') ? item.validDate.replaceAll('/', '-') + 'T00:00:00.000Z' : item.validDate
        item.createdDate = !item.createdDate.includes('T') ? item.createdDate.replaceAll('/', '-') + 'T00:00:00.000Z' : item.createdDate
      })

      this.loading = true
      this.model.image = this.images.find((item) => item !== this.model.selectedImage)

      if (this.dateRange.length === 1) {
        this.model.endDate = this.model.startDate
      }

      // this.model.installmentPayments = this.model.installmentPayments.map((item) => {
      //   const empty = this.model.installmentPayments.findIndex((item) => item.price === '')
      //   if (!item.price || !item.validDate) {
      //     this.model.installmentPayments.splice(empty, 1)
      //   }
      //   item.validDate = item.validDate?.includes('T') ? item.validDate.replaceAll('/', '-') + 'T00:00:00.000Z' : item.validDate
      //   return this.model.installmentPayments
      // })
      // const installmentPayments = this.model.installmentPayments.flat()
      // const uniq = [...new Set(installmentPayments)]
      if (this.model.price) {
        this.model.price = this.model.price.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.price = this.model.price
      }

      if (this.model.discount.length) {
        this.model.discount = this.model.discount.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.discount = +this.model.discount
      }

      if (this.endingImages.length === 0) {
        this.model.endingImages = ''
      }
      if (this.hireImages.length === 0) {
        this.model.hireImages = ''
      }

      if (this.endingImages.length > 0) {
        this.model.endingImages = this.endingImages.toString()
      }
      if (this.hireImages.length > 0) {
        this.model.hireImages = this.hireImages.toString()
      }
      // if (this.images.length === 0) {
      //   this.model.images = []
      // }
      if (!this.model.collegueId) {
        this.model.collegueId = null
      }
      this.model.installmentPayments = this.model.installmentPayments
        .filter((item) => typeof item.price === 'number')
        .map((item, index) => {
          if (typeof item.monthAfterBuy === 'string') {
            item.monthAfterBuy = index
          }
          return item
        })

      for (const key in this.model) {
        if (this.model[key] === '<p class="ql-align-right"><br></p>') {
          delete this.model[key]
        }
      }

      const payload = {
        ...this.model,
        startDate: this.model.startDate?.length ? this.model.startDate : undefined,
        endDate: this.model.endDate?.length ? this.model.endDate : undefined,
        releaseDate: this.model.releaseDate?.length ? new Date(this.model.releaseDate).toISOString() : undefined,
        discount: this.model.discount ? this.model.discount : undefined,
        deadlineDate: this.model.deadlineDate?.length ? this.model.deadlineDate : undefined,
        packageCategoryId: +this.model.packageCategoryId,
        price: +this.model.price,
        isEnable: !this.model.isEnable,
        facultyId: this.model.facultyId,
        packageProperties: this.model.packageProperties.filter((item) => item.title),
        capacity: +this.model.capacity <= 0 ? null : +this.model.capacity,
        order: this.model.order === '' ? null : +this.model.order,
      }

      try {
        if (this.update) {
          // await this.checkData()
          const req = await skillUpPackageProvider.updatePackage(payload)
          if (req.status === 200) {
            this.$emit('update', !this.updateForm)
            this.loading = false
          } else {
            this.error = true
            this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
          }
          return false
        }
        if (!this.model.price && !this.model.discount) {
          this.model.price = 0
          this.model.discount = 0
        }

        const req = await skillUpPackageProvider.addPackage(payload)
        if (req.status === 200) {
          this.message = 'بسته جامع با موفقیت ثبت شد.'

          this.checkRoute(req.data.data)
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        this.loading = false
      } finally {
        this.loading = false
      }
    },
    fillSelectedCertificate(e) {
      if (!e) {
        this.model.courseCertificateId = null
        this.model.hasCertificate = false
        return false
      }
      this.model.courseCertificateId = this.packageCertificates.find((item) => item.value === e).key
      this.model.hasCertificate = true
    },
    fillSelectedcollegue(e) {
      if (!e) {
        this.model.collegueId = null
        return false
      }
      this.model.collegueId = this.collegues.find((item) => item.value === e).key
      this.selectedCollegue = this.collegues.find((item) => item.value === e).value
    },
    async fetchPackage() {
      this.loading = true
      try {
        if (this.update) {
          const req2 = await skillUpPackageProvider.getPackage(+this.$route.params.packageId)
          this.model = req2.data.data.output
          this.numberOfAddedCourse = req2.data.data.output.numberOfAddedCourse
          localStorage.setItem('entityTitle', this.model.title)

          this.$emit('numberOfAddedCourse', this.numberOfAddedCourse)
          if (this.model.selectedImage) {
            this.images.push(this.model.selectedImage)
          }
          if (this.model?.installmentPayments?.length) {
            this.model.installmentPayments.sort((a, b) => a.order - b.order)
          }
          if (this.model?.advisorySettings?.length) {
            this.model.advisorySettings.sort((a, b) => a.order - b.order)
          }

          if (!this.model?.installmentPayments?.length) {
            this.model.installmentPayments = [
              {
                price: '',
                monthAfterBuy: '',
              },
            ]
          }
          if (!this.model?.advisorySettings?.length) {
            this.model.advisorySettings = [
              {
                createdDate: '',
                validDate: '',
              },
            ]
          }
          if (this.model.image) {
            this.images.push(this.model.image)
          }
          this.model.price = this.model.price.toString()
          if (this.model.discount) {
            this.model.discount = this.model.discount.toString()
          }

          if (this.model.startDate) {
            this.dateRange[0] = this.model.startDate.slice(0, 10).replaceAll('-', '/')
          }
          if (this.model.endDate) {
            this.dateRange[1] = this.model.endDate.slice(0, 10).replaceAll('-', '/')
          }

          this.packageCertificates.filter((item) => {
            if (item.key === this.model.courseCertificateId) {
              this.selectedCertificate = item.value
            }
          })

          this.courseFacultis.filter((item) => {
            if (item.key === this.model.facultyId) {
              this.selectedFaculti = item.value
            }
          })

          this.collegues.filter((item) => {
            if (item.key === this.model.collegueId) {
              this.selectedCollegue = item.value
            }
          })
          delete this.model.teachers
        }
        if (this.model.endingImages.length) {
          this.endingImages = this.model.endingImages.split(',')
        }
        if (this.model.hireImages.length) {
          this.hireImages = this.model.hireImages.split(',')
        }
        this.initialPackageProps(this.model.packageProperties)
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async fetchPackageInputs() {
      const req = await skillUpPackageProvider.getInputs()
      req.data.data.output.categories.forEach((item) => {
        this.packageCategories.push({ value: item.title, key: item.id })
      })

      req.data.data.output.faculties.forEach((item) => {
        this.courseFacultis.push({ value: item.title, key: item.id })
      })
      this.model.facultyId = req.data.data.output.id
      this.model.facultyTitle = req.data.data.output.title
      req.data.data.output.certificates.forEach((item) => {
        this.packageCertificates.push({ value: item.name, key: item.id })
      })
      req.data.data.output.collegues.forEach((item) => {
        this.collegues.push({ value: item.name, key: item.id })
      })
    },
    async uploadImage(e) {
      this.cropperLoading = true
      const req = await fileMannager.addImage({
        base64image: e,
      })
      this.images.push(req.data.data.downloadUrl)
      this.cropperLoading = false
    },
    removeCustomImage(payload, target) {
      const find = this[target].find((item) => item === payload.image)
      if (find) this[target].splice(payload.index, 1)
    },
    removeImage(payload) {
      this.images.splice(payload.index, 1)
      if (payload.image === this.model.image) {
        this.model.image = ''
      }
      if (payload.image === this.model.selectedImage) {
        this.model.selectedImage = ''
      }
      this.changeSelectedImage(payload.image)
    },

    preload(e, item) {
      this.model[item] = e
    },
    async deletePackage() {
      this.loading = true
      try {
        const req = await skillUpPackageProvider.deletePackage(+this.$route.params.packageId)
        this.$bvModal.hide('deleteModal')
        this.$router.push((!this.$route.path.includes('faculty') ? '/list/skilluppackages' : '/list/facultyskilluppackages') + localStorage.getItem('query'))
      } catch (error) {
        this.error = true
        this.loading = false
        this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        this.loading = false
      }
    },
    addFaculti(e) {
      this.model.facultyId = e.key
    },
    checkData() {
      // this.submit = true
      // for (const key in this.model) {
      //   if (this.model[key] === '' || this.model[key] === undefined || this.model[key] === null) {
      //     delete this.model[key]
      //   }
      // }
      if (this.model.price) {
        this.model.price = this.model.price.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.price = this.model.price
      }

      this.model.installmentPayments.forEach((item) => {
        const empty = this.model.installmentPayments.findIndex((item) => item.price === '')
        if (!item.price || !item.validDate) {
          this.model.installmentPayments.splice(empty, 1)
        }
        item.validDate = !item.validDate.includes('T') ? item.validDate.replaceAll('/', '-') + 'T00:00:00.000Z' : item.validDate
        if (item.price && item.price !== '') {
          item.price = item.price.replace(/[^a-zA-Z0-9 ]/g, '')
          item.price = +item.price
        }
      })
      this.model.advisorySettings.forEach((item) => {
        const empty = this.model.advisorySettings.findIndex((item) => item.createdDate === '')
        if (!item.createdDate || !item.validDate) {
          this.model.advisorySettings.splice(empty, 1)
        }
        item.validDate = !item.validDate.includes('T') ? item.validDate.replaceAll('/', '-') + 'T00:00:00.000Z' : item.validDate
        item.createdDate = !item.createdDate.includes('T') ? item.validDate.replaceAll('/', '-') + 'T00:00:00.000Z' : item.validDate
      })
    },
    changeSelectedImage(image) {
      if (this.model.selectedImage !== image) {
        this.model.selectedImage = image
        const imageDescription = this.model.selectedImageDescription
        const imageAlternateText = this.model.selectedImageAlternateText
        this.model.selectedImageAlternateText = this.model.imageAlternateText
        this.model.selectedImageDescription = this.model.imageDescription
        this.model.imageDescription = imageDescription
        this.model.imageAlternateText = imageAlternateText
      }
    },
    selectedBuyAfterMonth(item) {
      const find = this.month.find((m) => item.monthAfterBuy === m.key)
      if (find) {
        return find.key
      }
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.image {
  border-radius: 100%;
  width: 200px;
  height: 200px;
  margin: auto;
}

.upload_video {
  height: 281px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 25px;
  background-color: white;
}

.video {
  width: 100%;
  height: 122px;
  border-radius: 8px;
  // margin: 20px 20px 0 20px;
}

.pro {
  width: 210px;
}

.progress-b {
  margin: 15px auto;
  direction: ltr;
  width: 85%;
  position: relative;
  left: -10px;
}

.percent {
  width: 100%;
  font-size: 12px;
  display: inline-block;
  margin-left: 20px;
  margin-right: 20px;
  position: relative;
  top: -28px;
  right: -10px;
}

.upload_text {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}

.second_upload_text {
  font-size: 15px;
  text-align: center;
  margin-top: 10px;
  color: rgba(153, 150, 150, 1);
}

.close_icon {
  position: absolute;
  top: 2px;
  left: 15px;
  font-size: 20px;
  color: grey;
  cursor: pointer;
}

.part {
  display: inline-flex;
  width: 50%;
  strong {
    margin-left: 10px;
    min-width: 50px;
    display: flex;
    align-items: center;
  }
}

.tags {
  ::v-deep .badge-secondary {
    background: #dde3ff !important;
    font-size: 14px !important;
    color: #556be6 !important;
    margin: 2px;
    button {
      color: #556be6;
      background: #dde3ff;
    }
  }
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo-main {
  display: flex;
  flex-wrap: wrap;
}
.uploaded-photo {
  height: 120px;
  width: 150px;
  position: relative;
  margin-left: 10px;
  margin-bottom: 10px;
  img {
    width: 100%;
    height: 100%;
  }
}
.uploaded-video {
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  z-index: 1;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    color: #ff4861;
  }
}
.previewImage {
  border-radius: 4px;
}
.previewVideo {
  border-radius: 4px;
  width: 100%;
}

.checkbox-margin {
  margin-right: 8px;
}

.section-title {
  font-size: 16px;
}
::v-deep .custom-control-label {
  margin-right: 10px !important;
}

::v-deep .custom-control-input {
  border: 1px solid #556ee6 !important;
}

::v-deep .text-muted {
  display: none;
}

.date-header {
  font-size: 17px;
  margin: 16px;
}

.selected {
  border: 3px solid #556be6;
}

.upload-video-parent {
  width: 100%;
}

::v-deep .b-form-tags-button {
  display: none;
}
.accept-badge {
  width: 95px;
  height: 22px;
  font-size: 13px;
  color: #34c38f;
  text-align: center;
  background: rgba(52, 195, 143, 0.1);
  // border: 1px solid rgba(52, 195, 143, 0.3);
  border-radius: 100px;
}

.reject-badge {
  width: 95px;
  height: 22px;
  color: #f46a6a;
  font-size: 13px;
  text-align: center;
  background: rgba(244, 106, 106, 0.180392);
  // border: 1px solid rgba(255, 35, 87, 0.3);
  border-radius: 100px;
}

.need-badge {
  width: 95px;
  height: 22px;
  font-size: 13px;
  color: #556ee6;
  text-align: center;
  background: rgba(85, 110, 230, 0.1);
  // border: 1px solid rgba(85, 110, 230, 0.3);
  border-radius: 100px;
}

.waiting-badge {
  width: 95px;
  height: 22px;
  color: #fcbd35;
  font-size: 13px;
  text-align: center;
  background: rgba(240, 209, 34, 0.18);
  // border: 1px solid rgba(255, 35, 87, 0.3);
  border-radius: 100px;
}

::v-deep .card {
  overflow: visible;
}
::v-deep .labelStyle {
  min-width: 80px !important;
}

::v-deep .membersEnable .custom-control-label {
  margin: 0;
}

::v-deep .part .labelStyle {
  min-width: 0 !important;
}

::v-deep .part .label-no-width {
  padding-left: 12px !important;
}

.subject {
  max-height: 150px;
  min-height: 150px;
  overflow-y: auto;
}

.course_type_error {
  color: rgb(254, 94, 97);
}

::v-deep .input__style {
  font-weight: 600;
}

::v-deep .disableInput {
  color: black !important;
  font-weight: 600;
}
.disable {
  opacity: 0.5;
  pointer-events: none;
}

.buymethod {
  margin-left: 100px;
  ::v-deep .bv-no-focus-ring {
    display: flex;
    width: 100%;
    justify-content: space-between !important;
  }
}

.__icon {
  display: block;
  color: #74788d;
  font-size: 45px;
  text-align: center;
}

.month-after {
  position: absolute;
  top: 8px;
  right: 115px;
}

.subject-tip {
  margin: 20px auto;
  color: #556ee6;
}
</style>
